<template lang='pug'>
  form(:action="searchPath" method="get" ref="form")
    .searchbar.searchbar-rounded
      i.fal.fa-map-marker-alt
      input(type="hidden" name="by_population_id" :value="population_id")
      autocomplete-geolocation(@address-changed="$refs.form.submit()")
      .searchbar-submit
        button.btn.btn-secondary(type="submit")
          span {{ $t('components.search_bar_rounded.find') }}

</template>

<script>
  import AutocompleteGeolocation from '@appComponents/AutocompleteGeolocation'

  export default {
    props: {
      searchPath: String,
      population_id: Number
    },
    data () {
      return {
        queryParams: {}
      }
    },
    components: {AutocompleteGeolocation}
  }
</script>
